module.exports = __webpack_public_path__ + "files/a67c221b78c30878e122e3d718810144.png";